/* eslint-disable import/prefer-default-export */

export const USER_UPDATE = 'USER_UPDATE';
export const PRODUCT_MIX_UPDATE = 'PRODUCT_MIX_UPDATE';
